import { useAlertsMentionableUsers } from 'features/richText/hooks/useAlertsMentionableUsers'
import React from 'react'

import { MentionPluginBase } from './MentionPluginBase'

export interface AlertsMentionPluginProps {
  maxSuggestions?: number
}

export const AlertsMentionPlugin: React.FC<AlertsMentionPluginProps> = ({
  maxSuggestions = 10,
}) => {
  const { data: users, isLoading } = useAlertsMentionableUsers()
  return (
    <MentionPluginBase
      users={users}
      isLoading={isLoading}
      maxSuggestions={maxSuggestions}
    />
  )
}
